import { forwardRef } from "react";
import type { Ref } from "react";
import { NavLink as RouterNavLink } from "@/compat/router";

interface NavLinkWrapperProps {
  to: any;
  activeClassName?: string;
  exact?: boolean;
  className?: string;
  innerRef?: Ref<HTMLAnchorElement>;
  [key: string]: any;
}

// Bridges the react-router v5 NavLink props the sidebar still passes
// (`activeClassName`, `exact`, `innerRef`) to the v7 API:
//  - `innerRef`/ref  -> `ref`
//  - `exact`         -> `end`
//  - `activeClassName` -> appended via the `className` render function when active
// Consuming these here stops them leaking onto the DOM <a> element.
const NavLinkWrapper = forwardRef<HTMLAnchorElement, NavLinkWrapperProps>(
  ({ to, activeClassName = "active", exact = false, className, innerRef, ...props }, ref) => (
    <RouterNavLink
      to={to}
      ref={ref ?? innerRef}
      end={exact}
      className={({ isActive }) =>
        [className, isActive ? activeClassName : ""].filter(Boolean).join(" ")
      }
      {...props}
    />
  )
);

export default NavLinkWrapper;
